const FormResources = {

    form_data:{
        building_id:        '',
        level_id:           '',
        area_id:            '',
        task_id:            '',
        room_type_id:       '',
        floor_id:           '',
        cost_center_id:     '',
        closed:               '',
        essential_cleaning: '',
        policing:           '',
        project:            '',
        patient:            '',
        exclude_daily:      '',
        work_group:         '',
        exclude_project:    '',
        shift1:             '',
        shift2:             '',
        shift3:             '',
        freq_simbol:        1,
        frequency_id:       '',
    },

    scheduled_form_data:{
        building_id: '',
        level_id: '',
        area_id: '',
        project_task_id: '',
        all_rooms: false,
    },

    scheduled_form_format:[
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Building:',
            model_name: 'building_id',
            ref:        'building_id_input',
            ref_alt:    'building_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Level:',
            model_name: 'level_id',
            ref:        'level_id_input',
            ref_alt:    'level_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Area:',
            model_name: 'area_id',
            ref:        'area_id_input',
            ref_alt:    'area_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Project Task:',
            model_name: 'project_task_id',
            ref:        'project_task_id_input',
            ref_alt:    'project_task_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-12',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'All Rooms:',
            model_name: 'all_rooms',
            ref:        'all_rooms_input',
            ref_alt:    'all_rooms_input_alt',
            required:   false,
        },
    ],

    week_form_data: {
        sunday:     false,
        monday:     false,
        tuesday:    false,
        wednesday:  false,
        thursday:   false,
        friday:     false,
        saturday:   false,
    },

}

export default FormResources